import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { initialDataSlice } from '../store/initialData/initialData.slice';
import { useGAEventMeta } from './useGAEventMeta.hook';
import { GAService } from '../services/GAService';
export function useGALeadEvent() {
    var GAEventMeta = useGAEventMeta();
    var placementId = useSelector(initialDataSlice.selectors.getPlacementId);
    return useCallback(function () {
        GAService.onLeadCreated(placementId, GAEventMeta);
    }, [GAEventMeta, placementId]);
}
